import React, { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch } from "react-redux";

const tableRows = [
  {
    sensor: "HEART_RATE",
    value: "94",
    unit: "bpm",
    datetime: "26/01/2021 - 20:30:42",
  },
  {
    sensor: "OXYGEN",
    value: "98",
    unit: "%",
    datetime: "26/01/2021 - 20:30:42",
  },
  {
    sensor: "BLOOD_PRESSURE",
    value: "130/90",
    unit: "mmHg",
    datetime: "26/01/2021 - 20:30:42",
  },
  {
    sensor: "TEMPERATURE",
    value: "36.3",
    unit: "C",
    datetime: "26/01/2021 - 20:30:42",
  },
  {
    sensor: "STEPS",
    value: "630",
    unit: "Steps",
    datetime: "26/01/2021 - 20:30:42",
  },
  {
    sensor: "DISTANCE",
    value: "422",
    unit: "m",
    datetime: "26/01/2021 - 20:30:42",
  },
  {
    sensor: "CAL",
    value: "25",
    unit: "calories",
    datetime: "26/01/2021 - 20:30:42",
  },
];

const { TextArea } = Input;

const IoTAlertTableModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const dispatch = useDispatch();
  const handleOk = () => {
    dispatch({
      type: "SEND_MESSAGE",
      payload: { message: "IoT Item added", type: "IoT" },
    });
    setIsModalVisible(false);
  };

  return (
    <Modal
      title="IoT Alert"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="760px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row className="custom-table mt-4">
        <Col span={24}>
          <Row className="header">
            <Col md={6} xs={10}>Sensor</Col>
            <Col md={3} xs={6}>Value</Col>
            <Col md={3} xs={8}>Unit</Col>
            <Col md={3} xs={6}>Sleeping</Col>
            <Col md={3} xs={6}>Seating</Col>
            <Col md={3} xs={6}>Walking</Col>
            <Col md={3} xs={6}>Exercise</Col>
          </Row>
          {tableRows.map((item, idx) => (
            <Row
              className="table-row d-flex"
              id={`${idx}`}
              style={{ alignItems: "baseline" }}
            >
              <Col md={6} xs={10}>{item.sensor}</Col>
              <Col md={3} xs={6}>{item.value}</Col>
              <Col md={3} xs={8}>{item.unit}</Col>
              <Col md={3} xs={6}>
                <Input type="number" min={0} placeholder="Min" />
                <Input
                  type="number"
                  min={0}
                  placeholder="Max"
                  className="mt-1"
                />
              </Col>
              <Col md={3} xs={6}>
                <Input type="number" min={0} placeholder="Min" />
                <Input
                  type="number"
                  min={0}
                  placeholder="Max"
                  className="mt-1"
                />
              </Col>
              <Col md={3} xs={6}>
                <Input type="number" min={0} placeholder="Min" />
                <Input
                  type="number"
                  min={0}
                  placeholder="Max"
                  className="mt-1"
                />
              </Col>
              <Col md={3} xs={6}>
                <Input type="number" min={0} placeholder="Min" />
                <Input
                  type="number"
                  min={0}
                  placeholder="Max"
                  className="mt-1"
                />
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
      <Row className="action-grp mt-4">
        <Col span={14} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={handleOk}
          >
            Save
          </Button>
        </Col>
        <Col span={10} className="pl-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default IoTAlertTableModal;
